import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useSubscription } from '../contexts/SubscriptionContext';

const PaywallRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, justSignedIn, clearJustSignedIn } = useAuth();
  const { isSubscribed, isContextReady } = useSubscription();

  useEffect(() => {
    // Only run if:
    // 1. User is authenticated
    // 2. User just signed in
    // 3. Subscription context is ready
    // 4. Not already on login/register/paywall/dashboard pages
    if (
      currentUser && 
      justSignedIn && 
      isContextReady &&
      !isSubscribed &&
      !['/login', '/register', '/paywall', '/'].includes(location.pathname)
    ) {
      console.log('Redirecting unsubscribed user to paywall after signin');
      
      // Clear the flag first
      clearJustSignedIn();
      
      // Redirect to paywall
      navigate('/paywall', { 
        state: { 
          reason: 'post_signin',
          from: location 
        },
        replace: true 
      });
    } else if (justSignedIn) {
      // If user is subscribed or on dashboard, just clear the flag
      clearJustSignedIn();
    }
  }, [currentUser, justSignedIn, isSubscribed, isContextReady, location, navigate, clearJustSignedIn]);

  // This component doesn't render anything
  return null;
};

export default PaywallRedirect; 
